import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { CausaliMovmagService } from 'src/app/shared/services/causali-movmag.service';
import { MovimentiMagazzinoService } from 'src/app/shared/services/movimenti-magazzino.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { HttpErrorResponse } from '@angular/common/http';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { DecimalPipe } from '@angular/common';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-grid-movimentazioni-articoli-dipendenti',
  templateUrl: './grid-movimentazioni-articoli-dipendenti.component.html',
  styleUrls: ['./grid-movimentazioni-articoli-dipendenti.component.scss'],
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoTextsComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxiValidationRuleComponent,
    DxoLookupComponent,
    DxoEditingComponent,
    DecimalPipe,
    DxTemplateDirective
  ],
})
export class GridMovimentazioniArticoliDipendentiComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  @ViewChild('gridMov', { static: false }) dataGrid: DxDataGridComponent;
  @Input() idArticolo: number;
  @Input() idDipendente: number;

  listArticoli: any;
  listCaus: any;
  listArticoliMatricola: any;
  dataSource: any;
  popupNuovoMovimentoMagVisible = false;
  gestMatricole: boolean;

  columnResizingMode = 'widget';

  private movMagService = inject(MovimentiMagazzinoService);
  private articoliService = inject(ArticoliService);
  private causaliService = inject(CausaliMovmagService);
  private articoliMatricolaService = inject(ArticoliMatricolaService);

  constructor() {
    super();
    this.gestMatricole = this.isModVisible('Matricole');
    this.loadLookup();
  }

  ngOnInit() {
    this.loadData();
  }

  loadLookup() {
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = {
          store: {
            type: 'array',
            data: res.sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento articoli', 'error', 3000);
        }
      },
    });
    if (this.gestMatricole) {
      this.articoliMatricolaService.list().subscribe({
        next: (res) => {
          this.listArticoliMatricola = {
            store: {
              type: 'array',
              data: res,
              key: 'id',
            },
            pageSize: 10,
            paginate: true,
          };
        },
        error: (error) => {
          if (error?.error?.text) {
            const errT = error?.error?.text();
            const errj = JSON.parse(errT);
            notify(errj?.title, 'warning', 3000);
          } else {
            notify('Errore caricamento articoli matricola', 'error', 3000);
          }
        },
      });
    }
    this.causaliService.getListCausaliMovMagTemp().subscribe({
      next: (res) => {
        this.listCaus = {
          store: {
            type: 'array',
            data: res,
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento causali', 'error', 3000);
        }
      },
    });
  }

  loadData() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(
          this.movMagService.listByArticolo(this.idArticolo),
        )
          .then((response) => {
            console.log(JSON.stringify(response));
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        //Data
        const dt = new Date(values.data);
        const realDay = dt.getDate();
        const realMonth = dt.getMonth();
        const realYear = dt.getFullYear();
        values.data = new Date(Date.UTC(realYear, realMonth, realDay));

        return firstValueFrom(this.movMagService.post(values)).catch(() => {
          throw 'Insertion failed';
        });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.movMagService.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              console.log(error.error.title);
              throw error.error.title;
            })
        );
      },
    });
  }

  onInitNewRow(e) {
    setTimeout(() => {
      e.component.cancelEditData();
    }, 100);
    this.popupNuovoMovimentoMagVisible = true;
  }

  abs(value) {
    return Math.abs(value);
  }

  getArticoloDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }

  //Export excel
  onExporting(e) {
    GridExportExcel(
      e,
      'MovimentazioniMagazzino',
      'MovimwntazioniMagazzino.xlsx',
    );
  }

  /* Ordinamento lookup  */
  sortByLookup(data) {
    const column = this as any;
    const value = column.calculateCellValue(data);
    const ret = column.lookup.calculateCellValue(value);
    return ret;
  }
}
